<template>
    <base-button type="success" size="sm" icon="fa fa-plus fa-fw" @click="handleClick">Nuevo</base-button>
</template>
<script>
export default {
    name: "new-button",
    methods: {
        handleClick(evt) {
            this.$emit("click", evt);
        }
    }
};
</script>
<style>
</style>